module.exports = __webpack_public_path__ + "static/media/token.c697cbdb.png";